// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primaryButton {
  background-image: linear-gradient(to right, #07a7e3, #32dac3);
  color: white;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  width: 150px;
  text-align: center;
}
.primaryButton:hover {
  background-image: linear-gradient(to right, #07a7e3, #07a7e3);
}

.disabled {
  background-image: linear-gradient(to right, #dadada, #dadada);
  color: gray;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  width: 150px;
  text-align: center;
}
.disabled:hover {
  background-image: linear-gradient(to right, #dadada, #dadada);
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Buttons/PrimaryButton/PrimaryButton.scss"],"names":[],"mappings":"AAAA;EACI,6DAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACI,6DAAA;AAER;;AAEA;EACI,6DAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACI,6DAAA;EACA,mBAAA;AAER","sourcesContent":[".primaryButton {\n    background-image: linear-gradient(to right, #07a7e3, #32dac3);\n    color: white;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border: none;\n    border-radius: 10px;\n    padding: 10px 20px;\n    width: 150px;\n    text-align: center;\n    &:hover {\n        background-image: linear-gradient(to right, #07a7e3, #07a7e3);\n    }\n}\n\n.disabled {\n    background-image: linear-gradient(to right, #dadada, #dadada);\n    color: gray;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border: none;\n    border-radius: 10px;\n    padding: 10px 20px;\n    width: 150px;\n    text-align: center;\n    &:hover {\n        background-image: linear-gradient(to right, #dadada, #dadada);\n        cursor: not-allowed;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
